import React from 'react';

export function GrantsList({ parameters, onChange }) {
  return <div></div>;
}
